import { render } from "./InfoScreen.vue?vue&type=template&id=5d205a64"
import script from "./InfoScreen.vue?vue&type=script&lang=js"
export * from "./InfoScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jett\\Desktop\\bg-insieme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__